<template>
	<c-dialog ref="dialog" height="350" width="600" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
      <c-form-item label="属性" required tip="请选择属性">
        <c-select name="parent_id" v-model="parentId" async @search="searchAttribute"></c-select>
			</c-form-item>
      <c-form-item label="属性值" required tip="允许一次性增加多个属性值，各值之间以英文逗号分隔，重复数据、空数据将被忽略">
				<c-input type="textarea" name="attribute_values"></c-input>
			</c-form-item>
			<c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
			</c-form-item>
    </c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	computed: {
	},
	
	data() {
		return {
			  editState: false,
        parentId:0,        //已选中的属性ID
		}
	},

	methods: {
    /*******搜索属性*****************/
    searchAttribute(keyword, resolve){
      this.request({
        url:'/spu/attribute/options',
        data: {
          attribute_type:4,   //仅展示【选项类型】属性
          keyword: keyword
        },
        success:data => {
          resolve(data);
        }
      })
    },

		/*********打开编辑框，初始化**********/
		open() {
			this.$refs.form.clear();
			//填充form表单
			this.$refs.dialog.open({
				  title: '批量添加属性值'
			});
		},

		/*******添加、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: '/spu/attribute/value/add',
				rule: {
          parent_id: '请选择需要添加值的属性',
          attribute_values: '请选输入属性值信息',
        },
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
          this.$message({
            message: '添加成功',  // 提示内容,
            type: 'success'
          });
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>